<template>
  <div>
    <a-modal
      title="新增酒店手工下单"
      :visible="hotelVisible"
      width="600px"
      @cancel="chose"
      :footer="null"
      :hotelData="hotelData"
    >
      <a-form-model ref="ruleForm" :label-col="labelCol" :wrapper-col="wrapperCol" :model="ruleForm" :rules="rules">
        <a-form-model-item label="酒店名称">
          {{ hotelData.proName }}
        </a-form-model-item>
        <a-form-model-item label="房型价格计划" prop="ratePlanId">
          <a-select v-model="ruleForm.ratePlanId" placeholder="请选择" style="width: 100%;">
            <a-select-option v-for="(item, index) in hotelRatePlan" :value="item.ratePlanId" :key="index">
              {{ item.ratePlanName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="选择日期" :required="true">
          <div class="datePo">
            <div class="inputStyle" @click="chooseDate" v-if="afferentDate.checkInDate && afferentDate.departureDate">
              {{ '入住:' + afferentDate.checkInDate + ' | 离店' + afferentDate.departureDate }}
            </div>
            <div class="inputStyle" @click="chooseDate" v-else>请选择日期</div>
            <span class="spanPo" v-if="afferentDate.days">{{ afferentDate.days }}晚</span>
          </div>
        </a-form-model-item>
        <a-card :bordered="false" title="订单填写">
          <a-form-model-item label="房屋数" :required="true">
            <div class="houseNum">
              <img v-if="hotelNum == 1" src="../../../../../assets/images/reduce_unavailable2.png"/>
              <img v-else @click="reduceHouse" src="../../../../../assets/images/reduce_available2.png"/>
              <span>{{ hotelNum }}</span>
              <img @click="addHouse" src="../../../../../assets/images/add_available2.png"/>
            </div>
          </a-form-model-item>
          <a-form-model-item label="联系人" prop="contactName">
            <a-input style="width: 200px;" placeholder=" 请输入" v-model="ruleForm.contactName"/>
          </a-form-model-item>
          <a-form-model-item label="手机号码" prop="contactPhone">
            <a-input style="width: 200px;" placeholder=" 请输入" v-model="ruleForm.contactPhone" :maxLength="11"/>
          </a-form-model-item>
          <div v-for="(v, k) in checkInPersonList" :key="k">
            <a-form-model-item :label="k == 0 ? '入住人' : '入住人' + k" :required="true">
              <a-input style="width: 200px;" placeholder="请输入" v-model="v.travellersName"/>
            </a-form-model-item>
          </div>
          <a-form-model-item label="备注">
            <a-input style="width: 200px;" placeholder=" 请输入" v-model="ruleForm.orderRemark"/>
          </a-form-model-item>
          <a-form-model-item label="订单金额">
            ￥<span style="color: red; font-size: 18px;">{{ (Number(afferentDate.money) * hotelNum).toFixed(2) }}</span>
          </a-form-model-item>
        </a-card>
        <a-form-model-item label=" " :colon="false" :required="false">
          <a-button type="primary" @click="saveEvent" :loading="saveLoading">提交订单</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!--日期选择-->
    <class-choose-date
      :title="title"
      :dateVisible="dateVisible"
      ref="child"
      :date="afferentDate"
      :hotelData="hotelData"
      @childDate="getDate"
    >
    </class-choose-date>
  </div>
</template>

<script>
import searchForm from '../../../../../utils/mixins/searchFormMixins'
import formMixin from '../../../../../utils/mixins/formMixins'
import ClassChooseDate from '@/views/service/serviceProvider/resourceControl/components/ClassChooseDate'

export default {
  name: 'HotelChooseDate',
  components: { ClassChooseDate },
  mixins: [searchForm, formMixin],
  data() {
    return {
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      mode: 'month',
      hotelMonth: [],
      newArr: [],
      parentDate: {},//传入父组件的date数据
      title: '',
      labelCol: { span: 6 },
      wrapperCol: { span: 10 },
      ruleForm: {
        ratePlanId: '',
        contactName: '',
        contactPhone: '',
        orderRemark: ''
      },
      rules: {
        ratePlanId: [
          { required: true, message: '请选择价格计划', trigger: 'blur' }
        ],
        contactName: [
          { required: true, message: '请输入联系人姓名', trigger: 'blur' }
        ],
        contactPhone: [
          { required: true, message: '请输入联系人手机号', trigger: 'blur' },
          { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ]
      },
      inputNumber: 1,
      dateVisible: false,
      afferentDate: {
        checkInDate: '', //入住时间/出游时间
        departureDate: '',// 离店时间 非酒店类型传null ,
        money: 0,//订单单价
        proType: 1,//商品类型 1是酒店 否则其他
        days: 0,//天数
        minStock: 1//最小数量
      },
      hotelRatePlan: {},
      hotelNum: 1,
      checkInPersonList: [
        {
          cardNo: '',// 出游人证件号 ,
          cardType: '',// 出游人证件类型 ,
          travellersName: ''// 入住人/出游人 名称
        }
      ]
    }
  },
  props: {
    hotelData: {
      type: Object,
      default: null
    },
    hotelVisible: {
      type: Boolean,
      default: false
    }
  },
  created() {
  },
  mounted() {
    this.title = '选择入住和离店日期'
  },
  methods: {
    addHouse() {
      if (!this.ruleForm.ratePlanId) {
        this.$message.error('请选择价格计划')
        return false
      }
      if (!this.afferentDate.checkInDate && !this.afferentDate.departureDate) {
        this.$message.error('请选择时间')
        return false
      }
      if (this.hotelNum >= this.afferentDate.minStock) {
        return
      }
      this.hotelNum += 1
      this.checkInPersonList.push({
        cardNo: '',// 出游人证件号 ,
        cardType: '',// 出游人证件类型 ,
        travellersName: ''// 入住人/出游人 名称
      })
    },
    reduceHouse() {
      if (this.hotelNum <= 1) {
        return
      }
      this.hotelNum -= 1
      this.checkInPersonList.splice(this.checkInPersonList.length - 1, 1)
    },
    getDate(data) {
      this.afferentDate = data
      this.dateVisible = false
    },
    getHotelPanList(proId) {
      let parm = {
        proId
      }
      this.getHttpServices().getProService().post('resource/pro/get/hotelRatePlan', parm)
        .then(res => {
          this.hotelRatePlan = res
          this.getLogUtils().logWithTag('res', res)
          this.afferentDate = {
            checkInDate: '', //入住时间/出游时间
            departureDate: '',// 离店时间 非酒店类型传null ,
            money: 0,//订单单价
            proType: 1,//商品类型 1是酒店 否则其他
            days: 0,//天数
            minStock: 1//最小数量
          }
          this.hotelNum = 1
          this.ruleForm = {
            ratePlanId: '',
            contactName: '',
            contactPhone: '',
            orderRemark: ''
          }
          this.checkInPersonList = [
            {
              cardNo: '',// 出游人证件号 ,
              cardType: '',// 出游人证件类型 ,
              travellersName: ''// 入住人/出游人 名称
            }
          ]
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    chooseDate() {
      if (!this.ruleForm.ratePlanId) {
        this.$message.error('请选择价格计划')
        return false
      }
      this.hotelData.ratePlanId = this.ruleForm.ratePlanId
      this.$refs.child.getMonthHotel()
      this.dateVisible = true
    },
    saveEvent() {
      let flag = true
      this.checkInPersonList.forEach(item => {
        if (item.travellersName == '') {
          flag = false
        }
      })
      if (!flag) {
        this.$message.error('请输入入住人信息')
        return false
      }
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    submitData() {
      let ratePlanName = ''
      let optionId = 0
      let optionName = ''
      this.hotelRatePlan.forEach(v => {
        if (v.ratePlanId == this.ruleForm.ratePlanId) {
          ratePlanName = v.ratePlanName
          optionId = v.optionId
          optionName = v.optionName
        }
      })
      let params = {
        breakfastNum: null,//早餐数量 非酒店类型传null ,
        checkInDate: this.afferentDate.checkInDate,//入住时间/出游时间 ,
        contactName: this.ruleForm.contactName,//联系人名称 ,
        contactOtherInfoList: [],//订单联系人其他信息 ,
        contactPhone: this.ruleForm.contactPhone,
        departureDate: this.afferentDate.departureDate,//离店时间 非酒店类型传null ,
        optionId,//套餐ID
        optionName,//套餐名称
        orderAmount: Number(this.afferentDate.money) * this.hotelNum,//订单金额 ,
        orderRemark: this.ruleForm.orderRemark,
        proCatalog: this.hotelData.proCatalogId,//商品类型
        proId: this.hotelData.proId,
        proName: this.hotelData.proName,
        purchaseQuantity: this.hotelNum,
        ratePlanId: this.ruleForm.ratePlanId,
        ratePlanName,
        travellersDtoList: this.checkInPersonList
      }
      this.getHttpServices().getOrderService().post('resources/order/add/handworkOrder', params)
        .then(res => {
          this.$message.success('下单成功')
          this.$emit('choseDate')
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    chose() {
      //this.hotelVisible = false
      // this.checkStock(this.date.departureDate, this.date.checkInDate, this.date.departureDate)
      this.$emit('choseDate')
    }
  }
}
</script>
<style lang="less" scoped>
.ant-modal-body {
  min-height: 400px;
}

.inputStyle {
  width: 100%;
  border: 1px #d9d9d9 solid;
  border-radius: 5px;
  padding: 0 5px;
  cursor: pointer;
  display: inline-block;
}

.datePo {
  position: relative;

  .spanPo {
    display: block;
    position: absolute;
    top: 2px;
    right: -40px;
    color: red;
  }
}

.houseNum {
  display: flex;
  justify-content: flex-start;
  align-items: center;

  img {
    width: 30px;
    height: 30px;
    cursor: pointer;
  }

  span {
    display: inline-block;
    width: 30px;
    line-height: 28px;
    text-align: center;
    border: 1px #d9d9d9 solid;
  }
}
</style>
